module.exports = __webpack_public_path__ + "static/media/pin1.ee35cfce.svg";